var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnSun(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9998 14.6475C17.4914 14.6475 14.6473 17.4916 14.6473 21C14.6473 24.5084 17.4914 27.3525 20.9998 27.3525C24.5082 27.3525 27.3523 24.5084 27.3523 21C27.3523 17.4916 24.5082 14.6475 20.9998 14.6475ZM11.7598 21C11.7598 15.8969 15.8967 11.76 20.9998 11.76C26.1029 11.76 30.2398 15.8969 30.2398 21C30.2398 26.1031 26.1029 30.24 20.9998 30.24C15.8967 30.24 11.7598 26.1031 11.7598 21Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9997 0C21.9275 0 22.6797 0.626801 22.6797 1.4V7C22.6797 7.7732 21.9275 8.4 20.9997 8.4C20.0718 8.4 19.3197 7.7732 19.3197 7V1.4C19.3197 0.626801 20.0718 0 20.9997 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9997 33.6C21.9275 33.6 22.6797 34.2268 22.6797 35V40.6C22.6797 41.3732 21.9275 42 20.9997 42C20.0718 42 19.3197 41.3732 19.3197 40.6V35C19.3197 34.2268 20.0718 33.6 20.9997 33.6Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 21C42 21.9278 41.3732 22.68 40.6 22.68H35C34.2268 22.68 33.6 21.9278 33.6 21C33.6 20.0722 34.2268 19.32 35 19.32H40.6C41.3732 19.32 42 20.0722 42 21Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.40039 21C8.40039 21.9278 7.77359 22.68 7.00039 22.68H1.40039C0.627191 22.68 0.000390053 21.9278 0.000390053 21C0.000390053 20.0722 0.627191 19.32 1.40039 19.32H7.00039C7.77359 19.32 8.40039 20.0722 8.40039 21Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1861 5.81374C36.7478 6.37545 36.7478 7.28617 36.1861 7.84788L32.1178 11.9162C31.5561 12.4779 30.6453 12.4779 30.0836 11.9162C29.5219 11.3545 29.5219 10.4437 30.0836 9.88202L34.1519 5.81374C34.7136 5.25203 35.6243 5.25203 36.1861 5.81374Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9146 30.0838C12.4763 30.6455 12.4763 31.5562 11.9146 32.118L7.84628 36.1862C7.28457 36.748 6.37385 36.748 5.81214 36.1862C5.25043 35.6245 5.25043 34.7138 5.81214 34.1521L9.88043 30.0838C10.4421 29.5221 11.3529 29.5221 11.9146 30.0838Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.185 36.1862C35.6233 36.7479 34.7126 36.7479 34.1509 36.1862L30.0826 32.118C29.5209 31.5562 29.5209 30.6455 30.0826 30.0838C30.6443 29.5221 31.555 29.5221 32.1168 30.0838L36.185 34.1521C36.7468 34.7138 36.7468 35.6245 36.185 36.1862Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9155 11.9162C11.3538 12.4779 10.4431 12.4779 9.88137 11.9162L5.81308 7.84793C5.25137 7.28622 5.25137 6.3755 5.81308 5.81379C6.37479 5.25208 7.28551 5.25208 7.84722 5.81379L11.9155 9.88207C12.4772 10.4438 12.4772 11.3545 11.9155 11.9162Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSun);
export default __webpack_public_path__ + "static/media/icn-sun.b108149b6ec3e507961cbeb753ec881d.svg";
export { ForwardRef as ReactComponent };